export default __webpack_public_path__ + "static/media/bg2.feb4c62c.png";